export default __webpack_public_path__ + "static/funnel-steps-dark-mode-b8226f3551830ec96c259821d8d273bc.png";